var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"currentColor"},React.createElement("path",{"d":"M10 40h40v4H10zm0-24h40v4H10zm0 12h40v4H10z"})));
}

Menu.defaultProps = {"className":"svg-menu","viewBox":"0 0 60 60","stroke":"#000000","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
